import { render, staticRenderFns } from "./ActionDefaultTask.vue?vue&type=template&id=6539a844&scoped=true&"
import script from "./ActionDefaultTask.vue?vue&type=script&lang=js&"
export * from "./ActionDefaultTask.vue?vue&type=script&lang=js&"
import style0 from "./ActionDefaultTask.vue?vue&type=style&index=0&id=6539a844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6539a844",
  null
  
)

export default component.exports